module.exports = __webpack_public_path__ + "img/banner4.4555b566.jpg";